import React from 'react';
import { useState, useEffect } from 'react';
import '../App.css';
import { Input, Form, Container } from 'semantic-ui-react';

export default function Lost() {
  return (
    <div
      style={{
        minHeight: '100vh',
        background:
          'linear-gradient(139deg, rgba(175, 255, 139, 1) 0%, rgba(255, 191, 130, 1) 45%, rgba(255, 124, 123, 1) 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '30px',
          padding: '60px 40px',
          textAlign: 'center',
          maxWidth: '500px',
          width: '90%',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
        }}
      >
        {/* Chili Pepper Icon */}
        <div style={{ marginBottom: '30px' }}>
          <div
            style={{
              width: '120px',
              height: '120px',
              backgroundColor: 'white',
              borderRadius: '60px',
              margin: '0 auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
              marginBottom: '20px',
            }}
          >
            <img
              src="hot-pepper.png"
              alt="Hot pepper icon"
              style={{ height: '70px', width: 'auto' }}
            />
          </div>
        </div>

        {/* 404 Title */}
        <h1
          style={{
            fontSize: '72px',
            fontWeight: '800',
            color: 'rgb(250, 107, 5)',
            margin: '0 0 20px 0',
            letterSpacing: '-2px',
          }}
        >
          404
        </h1>

        {/* Main Message */}
        <h2
          style={{
            fontSize: '28px',
            fontWeight: '600',
            color: '#2c2c2c',
            margin: '0 0 16px 0',
          }}
        >
          Oops! You look lost.
        </h2>

        {/* Subtitle */}
        <p
          style={{
            fontSize: '18px',
            color: '#666',
            margin: '0 0 40px 0',
            lineHeight: '1.5',
          }}
        >
          This page seems to have vanished like a ghost pepper! 🌶️
        </p>

        {/* Navigation Buttons */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            alignItems: 'center',
          }}
        >
          <button
            onClick={() => (window.location.href = '/')}
            style={{
              backgroundColor: 'rgb(250, 107, 5)',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              padding: '16px 32px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(250, 107, 5, 0.3)',
              minWidth: '200px',
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = 'rgb(230, 90, 0)';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 16px rgba(250, 107, 5, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'rgb(250, 107, 5)';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(250, 107, 5, 0.3)';
            }}
          >
            🏠 Go to Home Page
          </button>

          <button
            onClick={() => (window.location.href = '/settings')}
            style={{
              backgroundColor: 'transparent',
              color: 'rgb(250, 107, 5)',
              border: '2px solid rgb(250, 107, 5)',
              borderRadius: '12px',
              padding: '14px 30px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              minWidth: '200px',
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = 'rgb(250, 107, 5)';
              e.target.style.color = 'white';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = 'rgb(250, 107, 5)';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            ⚙️ Go to Settings
          </button>
        </div>

        {/* Fun Footer Message */}
        <p
          style={{
            fontSize: '14px',
            color: '#999',
            marginTop: '40px',
            fontStyle: 'italic',
          }}
        >
          Don't worry, the chili cookoff is still hot! 🔥
        </p>
      </div>
    </div>
  );
}
